import {ParticipantInterface} from "@api/models/interfaces/meetings/ParticipantInterface";
import {UserProfile} from "../UserProfile";

export class Participant extends UserProfile {
    status?: string = undefined;
    profileId?: string = '';

    constructor(data: ParticipantInterface) {
        super(data as any);
        this.status = data.status ?? undefined;
        this.profileId = data.profileId || '';
        //Object.assign(this, data);
    }
}